import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../../styled-components/dark';
import { GenericMissionIcon } from '../../../assets/img';

type WrapperType = {
  $isCompact: boolean;
  $isFullWidth: boolean;
};

const Wrapper = styled.div<WrapperType>`
  display: inline-block;
  font-size: 1em;

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          font-size: 0.8em;
        `
      : null}

  ${({ $isFullWidth }) =>
    $isFullWidth
      ? css`
          display: block;
        `
      : null}
`;

type ContentType = {
  $isDark: boolean;
  $isFullWidth: boolean;
  $isCompact: boolean;
};

const Content = styled.div<ContentType>`
  border-radius: 0.4em;
  background: ${({ $isDark }) =>
    $isDark ? theme.MissionEligibleHeadband.backgroundColorDark : theme.MissionEligibleHeadband.backgroundColor};
  display: flex;
  padding: 0.3em 3em;

  ${({ $isFullWidth }) =>
    $isFullWidth
      ? css`
          justify-content: center;
        `
      : null}

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          padding: 0.2em 0.3em;
        `
      : null}
`;

const Label = styled.div`
  font-weight: bold;
  color: ${theme.MissionEligibleHeadband.color};
`;

const Icon = styled.img`
  width: 1.3em;
  margin-right: 0.3em;
`;

type MissionEligibleHeadbandProps = {
  className?: string;
  label?: string;
  isCompact?: boolean;
  isDark?: boolean;
  isFullWidth?: boolean;
};

const MissionEligibleHeadband = ({
  className = '',
  label,
  isCompact = false,
  isDark = false,
  isFullWidth = false,
}: MissionEligibleHeadbandProps) => {
  const [displayedLabel, setDisplayedLabel] = useState(label);

  useEffect(() => {
    setDisplayedLabel((prev) => (!prev && label ? label : prev));
  }, [label]);

  return displayedLabel ? (
    <Wrapper className={className} $isCompact={isCompact} $isFullWidth={isFullWidth}>
      <Content $isCompact={isCompact} $isDark={isDark} $isFullWidth={isFullWidth}>
        <Icon src={GenericMissionIcon} />
        <Label>{displayedLabel}</Label>
      </Content>
    </Wrapper>
  ) : null;
};

export default MissionEligibleHeadband;
